import {REPORT_NEW_GEN0_COACHES} from '/enum/records.enum';

export default {
  reportName: REPORT_NEW_GEN0_COACHES,
};
